import { CDN } from '../consts';

export type MarketingMedia =
  | { type: 'empty'; description: string }
  | { type: 'image'; description: string; src: string }
  | {
      type: 'video';
      description: string;
      src: string;
      mimeType: 'video/webm' | 'video/mp4';
      sources?: { src: string; type: string }[];
      fallbackSrc?: string;
    };

export function approvedVideo(
  filename: string,
  description: string,
): Extract<MarketingMedia, { type: 'video' }> {
  return {
    type: 'video',
    description,
    src: `${CDN}${filename}`,
    mimeType: filename.endsWith('.mp4') ? 'video/mp4' : 'video/webm',
  };
}

export function approvedVideoSource(filename: string, type: string) {
  return { src: `${CDN}${filename}`, type };
}

export function approvedImage(
  filename: string,
  description: string,
): Extract<MarketingMedia, { type: 'image' }> {
  return { type: 'image', description, src: `${CDN}${filename}` };
}
